import React, { createContext, useContext, useState } from 'react';
const PageRouteSourceContext = /*#__PURE__*/createContext(undefined);
export function usePageRouteSourceProvider() {
  const context = useContext(PageRouteSourceContext);
  if (context === undefined) {
    throw new Error('usePageRouteSourceProvider must be used within a PageRouteSourceProvider');
  }
  return context;
}
export function PageRouteSourceProvider(_ref) {
  let {
    children
  } = _ref;
  const [pageRouteSource, setPageRouteSource] = useState(null);
  const value = {
    pageRouteSource,
    setPageRouteSource
  };
  return /*#__PURE__*/React.createElement(PageRouteSourceContext.Provider, {
    value
  }, children);
}
export default PageRouteSourceProvider;